export const HOME_PAGE_TOAST_AUTO_HIDE_DURATION = 4000;

export const MAX_API_ATTEMPTS = 2;

export const AUTOMATION_REDIRECT_PARAMETER = 'identity_provider=trimble_automation';

export const MAX_RESET_PASSWORDS_EMAILS = 20;

export const MIN_RESET_PASSWORDS_EMAILS = 1;

export const MAX_UNLOCK_ACCOUNTS_EMAILS = 20;

export const MIN_UNLOCK_ACCOUNTS_EMAILS = 1;

export const AX_ACCESS_TOKEN_KEY = 'token';
